import { useLogService } from './useLogService';

export const useAuthAnalytics = () => {
  const { logEvent } = useLogService();

  const onModalOpenedEvent = (origin: string) => {
    logEvent('auth_modal_opened', undefined, { origin });
  };

  const onSignedUpEvent = ({
    optedInToSembonus,
  }: {
    optedInToSembonus: boolean;
  }) => {
    logEvent('user_signed_up', undefined, {
      optedInToSembonus: optedInToSembonus.toString(),
    });
  };

  const onLoggedInEvent = (isTravelAgent: boolean) => {
    logEvent('user_logged_in', undefined, {
      origin,
      isTravelAgent: isTravelAgent?.toString() || 'false',
    });
  };

  return { onModalOpenedEvent, onSignedUpEvent, onLoggedInEvent };
};
